export function checkStorageValue(value) {
  return ['true', 'false'].indexOf(value) >= 0 ? JSON.parse(value) : value;
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/checkStorageValue.js